// src/components/DashboardLayout.jsx
import { useState } from "react";
import { Outlet } from "react-router-dom"; 
import Sidebar from "./Sidebar";
import Header from "./Header";

const INDOMIE_LOGO = "https://sawake.kraitech.co.ke/images/logo.png";

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar 
        isOpen={sidebarOpen} 
        setIsOpen={setSidebarOpen} 
        logo={INDOMIE_LOGO} 
      />
      <div className="flex-1 flex flex-col min-w-0">
        <Header 
          sidebarOpen={sidebarOpen} 
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)} 
          logo={INDOMIE_LOGO} 
        />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
}